import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  
`

export const OrderStatusCard = styled.div`
  width: 100%;
  margin: 24px 0px;
  overflow: hidden;

  background: ${theme.colors.mainBg};
  border-radius: ${theme.border.normal};


  & > div {
    width: 100%;
    padding: 17px 25px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`

export const CreatedAt = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;

  & > p {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.normal};
    line-height: ${theme.font.sizes.medium};
    color: ${theme.colors.brown};

    & > em {
      margin-left: 22px;

      color: ${theme.colors.green};
      font-style: normal;
    }
  }
`

export const OrderId = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.medium};
  line-height: ${theme.font.sizes.large};
  color: #42425D;

  & > div {
    width: 6px;
    height: 6px;

    border-radius: 3px;
    background: ${theme.colors.brown};
  }
`

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 367px;
  gap: 22px;
`

export const Card = styled.div`
  background: ${theme.colors.mainBg};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.normal};
`

export const CostumerInfo = styled.ul`
  padding: 40px 25px;
  
  list-style: none;

  & > li {
    padding: 16px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & + li {
      border-top: 1px solid ${theme.colors.secondGray};
    }

    & > h4 {
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.medium};
      font-size: ${theme.font.sizes.normal};
      line-height: ${theme.font.sizes.medium};
      color: #42425D;
    }

    & > p {
      width: 170px;

      text-align: right;
      font-family: ${theme.font.inter};
      font-weight: ${theme.font.medium};
      font-size: ${theme.font.sizes.normal};
      line-height: ${theme.font.sizes.medium};
      color: #8D93A4;
    }
  }
`

export const PriceInfo = styled.div`
  width: 100%;
  height: 100%;
  padding: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`

export const DollarSignWrapper = styled.div`
  width: 77px;
  height: 77px;
  margin-top: 20px;

  border-radius: 77px;
  background: ${theme.colors.secondLightGray};

  display: flex;
  align-items: center;
  justify-content: center;
`

export const PriceFooter = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  & > h3 {
    text-align: left;
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.medium};
    font-size: ${theme.font.sizes.normal};
    line-height: ${theme.font.sizes.medium};
    color: #42425D;
  }

  & > p {
    text-align: left;
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.medium};
    font-size: ${theme.font.sizes.normal};
    line-height: ${theme.font.sizes.medium};
    color: #8D93A4;
  }
`
